import axios from 'axios';
import Cookies from 'js-cookie';
// Create a reusable Axios instance
const apiInstance = axios.create({
  baseURL: 'https://sales.credeux.com/api',
  withCredentials: true, // Ensures cookies are sent with requests
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN'
});

// Add CSRF token to every request
apiInstance.interceptors.request.use(config => {
  const xsrfToken = localStorage.getItem('csrf_token'); // Read CSRF token from cookie
  const accessToken = localStorage.getItem('access_token');

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  if (xsrfToken) {
    config.headers['X-XSRF-TOKEN'] = xsrfToken;
  }
  return config;
});

// Generic API request function
export const apiRequest = async (
  endpoint: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE', // Limit method types
  data?: any,
  config?: any
) => {
  try {
    const response = await apiInstance({
      url: endpoint,
      method,
      data,
      ...config // Allow custom config overrides
    });

    return response.data;
  } catch (error) {
    console.error(`Error with ${method} request to ${endpoint}:`, error);
    throw error;
  }
};
